module.exports = function() {
  return new Worker(__webpack_public_path__ + "d5610a24cf4db5cccd42.worker.js");
};